<script>
    export let soundEnabled = true;
    const english = () => `${soundEnabled ? 'Disable' : "Enable"} sound`;
</script>

<style>
    svg {
        display: block;
        height: 20px;
        width: 20px;
        cursor: pointer;
    }
    path.fill {
        fill: #fff;
    }
    path.stroke {
        fill: none;
        stroke: #fff;
        stroke-width: 1px;
        stroke-linecap: butt;
        stroke-linejoin: miter;
        stroke-opacity: 1;
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" alt={english}>
    <path class="fill" d="m0 10 1 1h2l4 4V1L3 5H1L0 6z"/>
    {#if soundEnabled}
        <path class="stroke" d="M9 6c1 1 1 3 0 4M11 4c2 2 2 6 0 8M13 2c3 3 3 9 0 12"/>
    {:else}
        <path class="fill" d="M10 5 9 6l2 2-2 2 1 1 2-2 2 2 1-1-2-2 2-2-1-1-2 2z"/>
    {/if}
</svg>